import { z } from 'zod';
import { IdSchema, MoneySchema } from '../common/index.js';

/**
 * Compensations entre héritiers (PARITE-5, démo isabelle/Compensations, réunion du 16/10 #26, RG-28, STA-06), ajout au contrat 1.0.0,
 * en LECTURE. Les sommes sont les avances d'un héritier pour un autre, calculées par le moteur de facturation sur les parts estimées.
 * La règle du remboursement en foncier manque : le calcul est toujours « à valider », avec la mention d'estimation ; la renonciation
 * reste la dernière piste et n'est jamais recommandée (RG-28). Équipe de bureau seulement.
 */
export const MENTION_ESTIMATION_COMPENSATION = 'Estimation indicative, ne vaut pas évaluation';

const PisteSchema = z.object({
  code: z.string().min(1),
  label: z.string().min(1),
  description: z.string().min(1),
  recommended: z.boolean(),
});

export const CompensationsDossierSchema = z
  .object({
    dossierId: IdSchema,
    warning: z.string().min(1),
    options: z
      .array(PisteSchema)
      .min(1)
      .refine((p) => p.findIndex((x) => x.code === 'renonciation') === -1 || p.at(-1)?.code === 'renonciation', {
        message: 'la renonciation reste la dernière piste (RG-28)',
      })
      .refine((p) => !p.some((x) => x.code === 'renonciation' && x.recommended), {
        message: 'la renonciation n’est jamais recommandée (RG-28)',
      }),
    debts: z.array(
      z.object({
        creditorPersonId: IdSchema,
        creditorDisplayName: z.string().min(1),
        debtorPersonId: IdSchema,
        debtorDisplayName: z.string().min(1),
        amount: MoneySchema,
      }),
    ),
    calculation: z.object({
      status: z.literal('a_valider'),
      note: z.string().min(1),
      mention: z.literal(MENTION_ESTIMATION_COMPENSATION),
    }),
    unavailableReason: z.string().nullable(),
    dataVersion: z.string().regex(/^\d+\.\d+\.\d+$/),
  })
  .meta({ id: 'CompensationsDossier', description: 'Sommes entre héritiers et pistes de remboursement (lecture, calcul à valider).' });
